import { SET_EMP_FORMPOST } from "../actions";

const empformpost = (state = [], action) => {
  switch (action.type) {
    case SET_EMP_FORMPOST:
      return [...action.value];
    default:
      return state;
  }
};

export default empformpost;
